"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function stak(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.4627 3.50925H12.471C14.025 5.04675 15.5617 6.59925 17.1067 8.145H20.9617L12.2842 20.4397C12.1402 18.996 12.0292 17.5522 11.9017 16.1092C13.1587 14.301 14.4495 12.5092 15.7065 10.7092L12.8362 7.848C12.8337 7.50958 12.8053 7.17186 12.7515 6.83775C12.6577 5.73375 12.5985 4.61325 12.4627 3.50925ZM3.04649 15.8542C5.95874 11.7622 8.84549 7.653 11.7495 3.552L12.1147 7.899C10.8495 9.70725 9.57599 11.4907 8.31074 13.2907C9.25349 14.2327 10.1955 15.192 11.1555 16.1347C11.283 17.5777 11.3932 19.0387 11.538 20.4907H11.52L6.90974 15.8715C5.61974 15.8887 4.32899 15.8632 3.03824 15.8887V15.8542H3.04649Z", fill: color }));
}
exports["default"] = stak;
//# sourceMappingURL=stak.js.map